import { InjectionToken } from '@angular/core';

/**
 * Shape of the build-time environment configuration injected via the ENVIRONMENT token.
 * Only values that must be baked into the compiled bundle at build time belong here.
 * Runtime configuration (employeePortalApiUrl, baseDomain, envSubdomainLabels, etc.) is loaded
 * from assets/api/environment.json via {@link EnvironmentService}.
 */
export interface BuildEnvironment {
  /** True only in production builds. Controls dev-only features such as the ?__customerId= override. */
  production: boolean;
}

/** Injection token that provides build-time {@link BuildEnvironment} values. */
export const ENVIRONMENT = new InjectionToken<BuildEnvironment>('ENVIRONMENT');
